var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7031 1.95312C23.1719 3.20313 23.9531 4.79688 24.0469 6.73438C24.1406 8.67188 23.5156 10.3125 22.1719 11.6562L13.125 21.0312C12.8125 21.3438 12.4531 21.5 12.0469 21.5C11.6406 21.5 11.2812 21.3438 10.9688 21.0312L1.92188 11.6562C0.578125 10.3125 -0.046875 8.67188 0.046875 6.73438C0.140625 4.79688 0.921875 3.20313 2.39062 1.95312C3.67188 0.859375 5.14062 0.390625 6.79688 0.546875C8.48438 0.671875 9.92188 1.34375 11.1094 2.5625L12.0469 3.5L12.9844 2.5625C14.1719 1.34375 15.5938 0.671875 17.25 0.546875C18.9375 0.390625 20.4219 0.859375 21.7031 1.95312Z",
    fill: "#FF6E4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHeart);
export default __webpack_public_path__ + "static/media/red-heart.1b2d9f1a.svg";
export { ForwardRef as ReactComponent };